export default __webpack_public_path__ + "static/media/11.0a6867d9.jpg";